module.exports = __webpack_public_path__ + "cw.bc7dcd425eac90baa476.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cw.svg
// module chunks = styles